import { LANGUAGES } from "src/app/core/config/config.constants";

export class MultiLangField {
  fieldTitle: string;
  defaultPlaceholder?: string;
  defaultValue?: string;
  labels: {
    lang: string;
    value: string;
  }[];

  constructor(title?) {
    this.fieldTitle = title || 'title';
    this.defaultPlaceholder = title ? `Enter ${title}` : 'Enter title';
    this.labels = [
      { lang: 'en', value: '' },
    ]
  }
}

export function setMultiLanguageField(titleConfig: MultiLangField) {
  let labels = titleConfig.labels;
  LANGUAGES.forEach(lang => {
    if (!labels.find(l => l.lang === lang.key)) {
      labels.push({ lang: lang.key, value: '' });
    }
  });
  return labels;
}

export function getMultiLanguageFieldTitle(titleConfig: MultiLangField): string {
  const lang = localStorage.getItem('language') || 'en';
  
  // Try to get the value for the current language
  const currentLangValue = titleConfig.labels.find(l => l.lang === lang)?.value;
  if (currentLangValue && currentLangValue.trim() !== '') {
    return currentLangValue;
  }
  
  // Fallback to English if current language is empty
  const enValue = titleConfig.labels.find(l => l.lang === 'en')?.value;
  if (enValue && enValue.trim() !== '') {
    return enValue;
  }
  
  // Fallback to first populated value if English is also empty
  const firstPopulated = titleConfig.labels.find(l => l.value && l.value.trim() !== '')?.value;
  return firstPopulated || '';
}

export function setDefaultMultiLanguageFieldTitle(titleConfig: MultiLangField) {
  const en = titleConfig.labels.find(l => l.lang === 'en')?.value;
  if (!en || en.trim() === '') {
    const def = titleConfig.labels.find(l => l.value && l.value.trim() !== '')?.value;
    return def || titleConfig.defaultPlaceholder || '';
  }
  return en;
}